
import Vue from 'vue';
import { Icon, Tab, Tabs } from '@descomplica/vue-components';
import LineSkeleton from '@/components/skeletons/atoms/LineSkeleton.vue';
import PostGradeAssessmentCardSkeleton from '@/components/skeletons/atoms/PostGradeAssessmentCardSkeleton.vue';

export default Vue.extend({
  components: {
    PostGradeAssessmentCardSkeleton,
    Icon,
    LineSkeleton,
    Tab,
    Tabs,
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
});
